<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="80">
      <v-btn text color="white">
        <base-img
          :src="require('@/assets/logo.png')"
          contain
          max-width="200"
          width="100%"
        />
      </v-btn>

      <v-row class="ml-10">{{ $i18n.t("Payment") }}</v-row>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "PaymentAppBar",
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

  .v-tab
    &::before
      display: none
</style>
